export default [
  { id: 'eu', name: 'Eurobeat' },
  { id: 'te', name: 'Techno' },
  { id: 'tr', name: 'Trance' },
  { id: 'ot', name: 'Other' }
]
